var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import apiClient from '@utils/api-client';
// ---------------------------------------------------------------------------
// POST /api/v1/ai/coach_welcome_acknowledgement (office portal, Rails session)
//
// Records that the current actor has seen the one-time IP Assistant Coach
// first-enable welcome (ipa-training-mode). When the widget is mounted in the
// Technician Portal, `configureApiClient` path-rewrites `/api/v1/ai/*` →
// `/api/technician_portal/ai/*`, so the same call reaches the field endpoint —
// exactly like tosApi.ts.
//
// Server is the cross-device source of truth; this write is best-effort.
// It NEVER throws: local state has already hidden the welcome for the session,
// and chat must never be blocked on this persistence (fail-open per plan).
// ---------------------------------------------------------------------------
const COACH_WELCOME_ACK_PATH = '/api/v1/ai/coach_welcome_acknowledgement';
export function acknowledgeCoachWelcome() {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            yield apiClient.post(COACH_WELCOME_ACK_PATH);
        }
        catch (error) {
            if (process.env.NODE_ENV !== 'production') {
                console.warn('[coachWelcomeApi] acknowledgement failed (non-blocking):', error);
            }
        }
    });
}
